import React from 'react';
import Modal from '../../../Modal';
import { ForgotPassword } from '../../../Authorization';
import { bodyScrollFix } from '../../../../utils';

export default ({ onOk, visible, isLoading, onReset, ...rest }) => {
  return (
    <Modal
      title={null}
      open={visible}
      footer={null}
      width={'auto'}
      {...rest}
      wrapClassName="auth"
      afterClose={bodyScrollFix}
    >
      <ForgotPassword onOk={onOk} visible={visible} />
    </Modal>
  );
};
